import React from 'react';
import { IconButton, CircularProgress, Badge, Box, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => ({
    buttonProgress: {
        color: theme.palette.primary,
        position: 'absolute'
    },
    percentages: {
        color: "#FFFFFF"
    }
});

const CircleProgressIconButtonBadge = withStyles(Badge, (theme) => ({
    badge: {
        fontSize: '0.65rem',
        right: 6,
        backgroundColor: theme.palette.warning.main,
        right: 10,
        top: 10,
        transform: 'scale(0.5)',
        pointerEvents: 'none'
    }
}));


const CircularProgressWithLabel = (props) => {
    const { value, size, classes } = props;

    return (
        <Box position="absolute" display="flex">
            <CircularProgress size={size ? size : 24} value={value} variant="determinate" />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography className={classes.percentages} style={{ fontWeight: 700 }} variant="caption" component="div">{`${Math.round(value,)}%`}</Typography>
            </Box>
        </Box>
    );
}

const SaveVideoCircleProgress = (props) => {
    const { classes, className, loading, progressSize, disabled, progress, children, badge, ...other } = props;

    return (
        <CircleProgressIconButtonBadge badgeContent={""} invisible={!badge}>
            <Box>
                <IconButton
                    className={className}
                    disabled={disabled}
                    {...other}
                    size="large"
                >
                    {children}
                    {loading && <CircularProgress size={progressSize ? progressSize : 24} className={classes.buttonProgress} />}
                </IconButton>
            </Box>
        </CircleProgressIconButtonBadge>
    );
}

export default withStyles(SaveVideoCircleProgress, styles);